import "./Account.css";
import React, { useState, useEffect, useContext } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { UserContext } from "../../contexts/CurrentUserContext";
// Удалите импорт UserProvider
import EmployeeCard from "../EmployeeCard/EmployeeCard";
import SubHeader from "../Subheader/Subheader";
import Admin from "./Admin/Admin";
import Logout from "../Logout/Logout.js";
import Preloader from "../Preloader/Preloader";
// import PayslipWithSelector from "../Payslip/PayslipWithSelector";
import Extrahours from "./Extrahours/Extrahours";
import NewPayslip from "../Payslip/NewPayslip/NewPayslip";
import Discipline from "./Discipline/Discipline";
function Account() {
  const { userData } = useContext(UserContext);

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Имитация загрузки данных
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  }, []);

  const allTabs = [
    {
      id: 1,
      label: "ЛИЧНАЯ КАРТОЧКА",
      path: "employee-card",
      Component: EmployeeCard,
    },
    {
      id: "overtime",
      label: "ПЕРЕРАБОТКИ И ОТГУЛЫ",
      path: "overtime",
      Component: Extrahours,
    },
    {
      id: "new-payslip",
      label: "РАСЧЕТНЫЙ ЛИСТ",
      path: "new-payslip",
      Component: NewPayslip,
    },
    {
      id: "discipline",
      label: "ДИСЦИПЛИНА",
      path: "discipline",
      Component: Discipline,
    },
    {
      id: 6,
      label: "АДМИНИСТРИРОВАНИЕ ПОЛЬЗОВАТЕЛЕЙ",
      path: "admin/register",
      Component: Admin,
    },
    { id: 7, label: "ВЫЙТИ", path: "logout", Component: Logout },
  ];

  // Проверка роли пользователя
  const hasAdminAccess =
    userData &&
    userData.access_levels &&
    userData.access_levels.some((level) =>
      ["АДМС", "ИК", "ФИН", "СИСТЕМАДМ"].includes(level.name)
    );

  // Определяем вкладки, доступные для обычных пользователей
  const allowedTabsForNonAdmin = [
    "ЛИЧНАЯ КАРТОЧКА",
    "РАСЧЕТНЫЙ ЛИСТ",
    "ПЕРЕРАБОТКИ И ОТГУЛЫ",
    "ДИСЦИПЛИНА",
    "ВЫЙТИ",
  ];

  // Фильтруем вкладки
  const filteredTabs = allTabs.filter((tab) => {
    return hasAdminAccess ? true : allowedTabsForNonAdmin.includes(tab.label);
  });

  return (
    <section className="account">
      {isLoading ? (
        <Preloader />
      ) : (
        <>
          <SubHeader tabs={filteredTabs} />
          <Routes>
            {filteredTabs.map((tab) => (
              <Route key={tab.id} path={tab.path} element={<tab.Component />} />
            ))}
            <Route path="/" element={<Navigate to="employee-card" />} />
            {hasAdminAccess && <Route path="admin/*" element={<Admin />} />}
          </Routes>
        </>
      )}
    </section>
  );
}

export default Account;
